
import React from 'react';
import addToMailchimp from 'gatsby-plugin-mailchimp';
import Button from "../Button/button"


class Form extends React.Component {
  state = {
    name: null,
    email: null,
}

_handleChange = e => {
  console.log({
      [`${e.target.name}`]: e.target.value,
  })
  this.setState({
      [`${e.target.name}`]: e.target.value,
  })
}

_handleSubmit = e => {
  e.preventDefault()

  console.log('submit', this.state)

  addToMailchimp(this.state.email, this.state)
      .then(({ msg, result }) => {
          console.log('msg', `${result}: ${msg}`)

          if (result !== 'success') {
              throw msg
          }
          alert(msg)
      })
      .catch(err => {
          console.log('err', err)
          alert(err)
      })
}
  
  render() {
    return (
      <form onSubmit={this._handleSubmit}>
        <div className="row">
          <div className="input-area">
            <input 
              id="input_name"
              type="text"
              onChange={this._handleChange} 
              name="name" 
              // placeholder="Name" 
              required autoComplete="off"
            />
            <label className="label-name" htmlFor="input_name">
              <span className="content-name">Name</span>
            </label>
          </div>
          <div className="input-area">
            <input 
              id="input_email"
              type="text" 
              onChange={this._handleChange}
              name="email" 
              // placeholder="Email" 
              required autoComplete="off"
            />
            <label className="label-name" htmlFor="input_email">
              <span className="content-name">Email</span>
            </label>            
          </div>          
          <div className="input-area button-area">
            <Button cta="Submit" type="submit" />
            {/* <input type="submit" value="Submit" /> */}
          </div>
        </div>
    </form>    
    );
  }
}

export default Form;
